<style src="./subscription.scss">
</style>

<script lang="ts">
  import Modal from "@components/modal";
  import Button from "@components/button";
  import Icon from "svelte-icon";
  import Badge from "@components/badge";

  import AppStore from "@assets/images/appstore.svg";
  import GooglePlay from "@assets/images/googleplay.svg";

  export let isOpen = false;
  export let onClose = () => null;
  export let product = null;
</script>

<Modal
  isOpen="{isOpen}"
  title="Você já possui uma assinatura:"
  onClose="{onClose}">
  <div class="subscription-modal">
    {#if product}
      <div class="subscription-modal__product">
        <Badge title="{product.name}" background="{product.color}" />
      </div>
    {/if}

    <p>
      Baixe o app para explorar um novo jeito de aprender inglês online, melhor
      e mais rápido.
    </p>
    <div class="stores">
      <a
        href="https://apps.apple.com/br/app/cna-go/id1529651631"
        target="_blank">
        <Icon data="{AppStore}" stroke="transparent" fill="transparent" />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=br.com.cnago.app"
        target="_blank">
        <Icon data="{GooglePlay}" stroke="transparent" fill="transparent" />
      </a>
    </div>

    <h1>Quer adquirir uma nova assinatura?</h1>
    <Button
      title="Assinar com outro e-mail"
      onClick="{onClose}"
      type="{'secondary'}" />
  </div>
</Modal>
